module.exports = __webpack_public_path__ + "static/1d-73bd63bbec6bae76bffe38187f1d32d3.svg";